'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

require('../util/validators/password-validator.js');
require('../util/helpers/strings.js');
require('../util/helpers/date.js');
require('../util/helpers/arrays.js');
require('../util/helpers/language.js');
require('../util/helpers/numbers.js');
var Vue = _interopDefault(require('vue'));
var vuePropertyDecorator = require('vue-property-decorator');
require('../util/helpers/currency.js');
var dom = require('../util/helpers/dom.js');
require('../util/helpers/debounce.js');
require('../util/helpers/throttle.js');
require('../util/helpers/functions.js');
require('../util/helpers/session.js');
require('../util/helpers/forms.js');
require('../util/helpers/keys.js');
require('../util/helpers/game.js');
require('../util/helpers/game-category.js');
require('../util/helpers/script.js');
require('../util/helpers/events.js');
require('../util/helpers/password.js');
require('../util/helpers/storage.js');
require('../util/helpers/theming.js');
require('../util/helpers/objects.js');
require('../util/helpers/slots.js');
require('../util/helpers/phone.js');
require('../util/validators/date-validator.js');
require('../util/validators/debounce-validator.js');
require('../util/types/input.js');
require('../util/types/device.enum.js');
require('../services/cdn/cdn.service.js');
require('../services/scroll/scroll.service.js');
require('../services/modal/modal.constants.js');
var modal_service = require('../services/modal/modal.service.js');
require('../services/links/links.service.js');
require('../services/native-app/app.service.js');
require('../services/tracking/tracking.service.js');
require('../services/feature/feature.decoratorV2.js');

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
exports.ModalMixin = class extends Vue {
  constructor() {
    super(...arguments);
    this.modal = null;
  }
  destroyed() {
    this.closeModal();
  }
  openModal(contentElement, title, options = {}) {
    var _a, _b;
    if (this.modal) {
      return this.modal.body;
    }
    if (typeof contentElement === "string") {
      contentElement = document.createElement(contentElement);
    }
    let vueInstance = null;
    if (!dom.isElement(contentElement)) {
      const ContentVueClass = class extends vuePropertyDecorator.Mixins(contentElement) {
      };
      vueInstance = new ContentVueClass({
        propsData: (_a = options.props) != null ? _a : {},
        data: (_b = options.data) != null ? _b : {}
      });
      contentElement = vueInstance.$mount().$el;
    }
    this.modal = modal_service.modalService.open(title, contentElement, __spreadProps(__spreadValues({}, options), {
      onClose: (closeButton, params) => {
        this.modal = null;
        if (typeof options.onClose === "function") {
          options.onClose(closeButton, params);
        }
        if (vueInstance) {
          vueInstance.$destroy();
        }
      }
    }));
    return contentElement;
  }
  closeModal(closeButton = false, params) {
    if (!this.modal) {
      return;
    }
    modal_service.modalService.close(this.modal, closeButton, params);
  }
  hasModal() {
    return !!this.modal;
  }
};
exports.ModalMixin = __decorateClass([
  vuePropertyDecorator.Component
], exports.ModalMixin);
